import { Drawer } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import useStore from "../../store";

// TODO: useState for isResizing, update with on state Change
let isResizing = null;
let currentWidth = 0;

export default function SideBar(props) {
    const enabled = useStore((store) => store.dashboard.sidebars.right.enabled);
    const width = useStore((store) => store.dashboard.sidebars.right.width);
    const setWidth = useStore((store) => store.dashboard.sidebars.setWidth);
    const darkMode = useStore((store) => store.app.darkMode);

    const [windowWidth, setWindowWidth] = useState(0);

    const resizeWindow = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    const draggerRef = useRef();

    // eslint-disable-next-line no-use-before-define
    const cbHandleMouseMove = React.useCallback(handleMousemove, []);
    // eslint-disable-next-line no-use-before-define
    const cbHandleMouseUp = React.useCallback(handleMouseup, []);

    const dragHandleStyle = {
        width: "5px",
        cursor: "ew-resize",
        padding: "4px 0 0",
        // borderTop: "1px solid #ddd",
        // marginRight: -10,
        position: "absolute",
        top: 0,
        right: "initial",
        bottom: 0,
        left: 0,
        zIndex: "900",
        backgroundColor: darkMode ? "#383838" : "#efefef",
    };

    if (!enabled) {
        dragHandleStyle.display = "none";
    }

    useEffect(() => {
        window.dispatchEvent(new Event("resize"));
        // setLocalWidth(width);
        currentWidth = width;
        draggerRef.current.style.left = `${(document.body.offsetWidth - currentWidth)}px`;
    }, [width]);

    function handleMousedown(e) {
        e.stopPropagation();
        e.preventDefault();
        // we will only add listeners when needed, and remove them afterward
        document.addEventListener("mousemove", cbHandleMouseMove);
        document.addEventListener("mouseup", cbHandleMouseUp);
        isResizing = true;
    }

    function handleMousemove(e) {
        if (!isResizing) {
            return;
        }

        const offset = document.body.offsetWidth - (e.clientX - document.body.offsetLeft);

        const minWidth = 50;
        if (offset >= minWidth) {
            currentWidth = offset;

            draggerRef.current.style.left = `${(document.body.offsetWidth - currentWidth)}px`;
        }
    }

    function handleMouseup() {
        if (!isResizing) {
            return;
        }

        setWidth("right", currentWidth);
        isResizing = false;
        document.removeEventListener("mousemove", cbHandleMouseMove);
        document.removeEventListener("mouseup", cbHandleMouseUp);
    }

    useEffect(() => {
        draggerRef.current.style.left = `${(document.body.offsetWidth - currentWidth)}px`;
    }, [windowWidth]);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
                ref={draggerRef}
                className="sidebar-dragger"
                onMouseDown={handleMousedown}
                style={dragHandleStyle}
            />
            <Drawer
                style={{ width: enabled ? width : null }}
                variant="persistent"
                anchor="right"
                open={enabled}
                PaperProps={{
                    style: {
                        width, overflow: "hidden", padding: 0, height: "100%", paddingLeft: 10,
                    },
                    className: "ptm-sidebar",
                }}
            >
                <div style={{ width: "calc(100% - 5px)", height: "100%", marginLeft: 5 }}>
                    {React.Children.map(props.children, (child) => React.cloneElement(child, { children: { ...child.props.children, props: { ...child.props.children.props, enabled } } }))}
                </div>
            </Drawer>
        </>
    );
}
